<template>
  <!-- <div class="card">
    <div class="card-header border-0"> -->
  <a-drawer
    title=""
    width="500"
    placement="right"
    @close="onClose"
    :visible="filterVisible"
  >
    <a-spin :spinning="fetchingFull">
      <div class="row">
        <div class="col-md-12">
          <h3>Advanced Filter</h3>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-12" v-if="userDefinedFields.length > 0">
          <h6 class="heading-small text-muted text-truncate">OTHER FILTERS</h6>
          <!-- {{userDefinedFilters}} -->
          <div class="dynamic-form">
            <dynamic-form
              :convertedJson="{
                mode: customForm.mode,
                groups: customForm.groups_append,
                parentClass: 'product-advance-filter'
              }"
              :formSettings="userDefinedFilters"
              :key="dynamicFormKey"
            />
          </div>
          <!-- <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="product" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/> -->
          <!-- <small> <span class="fa fa-info-circle"/> Use this feature to filter product via user-defined fields. </small> -->
          <!-- <div v-for="field in userDefinedFields" :key="field.key">
              <base-input v-if="field.data_type == 'string'" :label="_.startCase(field.name)">
                <a-input type="text" />
              </base-input>
              <base-input v-if="field.data_type == 'integer'" :label="_.startCase(field.name)">
                <a-input type="number" />
              </base-input>
              <base-input v-if="field.data_type == 'datetime'" :label="_.startCase(field.name)">
                  <br><a-date-picker/>
              </base-input>
              <base-input v-if="field.data_type == 'boolean'" :label="_.startCase(field.name)">
                <br><a-checkbox > {{ _.startCase(field.name) }}</a-checkbox>
              </base-input>
            </div> -->
        </div>

        <div class="col-md-12">
          <br />
          <base-input label="Category">
            <br />
            <a-cascader
              v-model="inputCategory"
              :options="categoriesOptions"
              :showSearch="{ filter }"
              placeholder="Please select category"
              style="width: 100%"
              changeOnSelect
            />
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Brand">
            <br />
            <a-select
              mode="multiple"
              style="width: 100%"
              placeholder="Please select brand"
              :filterOption="false"
              :notFoundContent="fetching ? undefined : null"
              :value="valueToReturn"
              @search="handleSearch"
              @change="handleChange($event,'valueToReturn', 'inputBrand')"
            >
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option
                v-for="option in brandOptions"
                :key="option.id"
                :value="option.id"
                >{{ option.name }}</a-select-option
              >
            </a-select>

            <!-- <a-select v-model="inputBrand" showSearch mode="multiple" placeholder="Select Brands"
              optionFilterProp="children" style="width: 100%"
              :filterOption="filterOption">
              <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select> -->
          </base-input>
        </div>
        <div class="col-md-12">
          <base-input label="Sub Brand">
            <a-select
             mode="multiple"
             style="width: 100%"
             placeholder="Please select sub brand"
             :filterOption="false"
             showSearch
             :value="subBrandValue"
             @change="handleChange($event,'subBrandValue', 'inputSubBrand')"
             >
             <a-select-option
              v-for="option in subBrandOptions"
              :key="option.id"
              :value="option.id"
             >{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Product Grade Level">
            <a-select
              v-model="inputProductGrade"
              showSearch
              mode="multiple"
              placeholder="Select Product Grade Level"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="option in productGradeOptions"
                :key="option"
                :value="option"
                >{{ option }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Product Groups">
            <a-select
              v-model="inputProductGroup"
              showSearch
              mode="multiple"
              placeholder="Select Product Groups"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="option in productGroupOptions"
                :key="option.id"
                :value="option.id"
                >{{ option.name }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>


        <div class="col-md-12">
          <base-input label="Product Series Name">
            <a-select
              v-model="inputProductSeriesName"
              showSearch
              mode="multiple"
              placeholder="Select Product Series Name"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="option in productSeriesNameOptions"
                :key="option.key"
                :value="option.name"
                >{{ option.name }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Product Series Date">
            <a-date-picker
              name="series_date"
              class="series_date_field"
              :format="dateFormat"
              v-model="inputProductSeriesDate"
              placeholder="Select date"
              @change="updateProductSeriesDate"
            />
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Supplier Type">
            <br />
            <a-select
              v-model="inputSupplierType"
              showSearch
              placeholder="Select a Supplier Type"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option value="0">All</a-select-option>
              <a-select-option
                v-for="option in supplierTypeOptions"
                :key="option.id"
                :value="option.id"
                >{{ option.name }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Supplier">
            <br />
            <a-select
              v-model="inputSupplier"
              showSearch
              placeholder="Select a Supplier"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="option in supplierOptions"
                :key="option.id"
                :value="option.id"
                >{{ option.name }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Last Retail Price Change">
            <a-range-picker v-model="inputDate" @change="onDateFilter" />
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Status">
            <br />
            <a-select
              v-model="statusFilter"
              style="width: 100%"
              placeholder="Please select Statis"
              optionFilterProp="children"
            >
              <a-select-option value="0">All</a-select-option>
              <a-select-option value="A">Active</a-select-option>
              <a-select-option value="I">In-Active</a-select-option>
              <a-select-option value="P">Phased Out</a-select-option>
              <a-select-option value="D">Deleted</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Tags">
            <a-select
              v-model="inputTag"
              showSearch
              mode="multiple"
              placeholder="Select Tags"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="option in tagOptions"
                :key="option.id"
                :value="option.id"
                >{{ option.name }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Properties">
            <a-select
              v-model="inputProperty"
              showSearch
              mode="multiple"
              placeholder="Select Properties"
              optionFilterProp="children"
              style="width: 100%"
              :filterOption="filterOption"
            >
              <a-select-option
                v-for="option in propertiesOptions"
                :key="option.id"
                :value="option.id"
                >{{ option.name }}</a-select-option
              >
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Create Date">
            <a-date-picker
              name="series_date"
              class="series_date_field"
              :format="dateFormat"
              v-model="inputProductCreateDate"
              placeholder="Select date"
              @change="updateProductCreateDate"
            />
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Update Date">
            <a-date-picker
              name="series_date"
              class="series_date_field"
              :format="dateFormat"
              v-model="inputProductUpdateDate"
              placeholder="Select date"
              @change="updateProductUpdateDate"
            />
          </base-input>
        </div>

        <div class="col-md-12 mb-3">
          <a-checkbox v-model="isNonTrade">Non-Trade</a-checkbox>
        </div>

        <h6 class="col-md-12 heading-small text-muted mb-4 text-truncate">
          PRICE & COSTING FILTERS
        </h6>
        <div class="col-md-12">
          <base-input
            label="Retail Price"
            v-model="inputRetailPrice"
            type="number"
            min=0
            placeholder="Retail Price"
          >
          </base-input>
        </div>
        <div class="col-md-12 mb-3">
          <a-checkbox >Zero Price Products</a-checkbox>
        </div>
        <br/>
        <div class="col-md-12 mb-3">
          <a-checkbox>Zero Cost Products</a-checkbox>
        </div>

        <h6 class="col-md-12 heading-small text-muted mb-4 text-truncate">
          STOCK FILTERS
        </h6>

        <div class="col-md-6">
          <div>
            <base-radio name="0" class="mb-3" v-model="stockStatus">
              All
            </base-radio>
            <base-radio name="1" class="mb-3" v-model="stockStatus">
              Out of Stock
            </base-radio>
            <base-radio name="2" class="mb-3" v-model="stockStatus">
              On Stock
            </base-radio>
            <base-radio name="3" class="mb-3" v-model="stockStatus">
              Negative Stock
            </base-radio>
          </div>
          <br />
        </div>
      </div>
    </a-spin>
    <div
      style="
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: -webkit-fill-available;
        background-color: #f2f2f2;
        padding: 10px;
      "
    >
      <button
        class="btn btn-sm btn-primary float-right"
        style="width: 30%"
        @click.prevent="updateParams"
      >
        Apply
      </button>
      <button
        class="btn btn-sm float-right"
        style="
          background-color: #394a5d;
          color: white;
          width: 30%;
          margin-right: 5%;
        "
        @click.prevent="clearFilter"
      >
        Clear
      </button>
    </div>
  </a-drawer>

  <!-- </div>
  </div> -->
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import DynamicForm from "../DynamicForm.vue";
import { mapState, mapActions } from "vuex";

import moment from "moment";
// import {
//   async
// } from 'q'

export default {
  props: ["currentFilter", "params", "parentParams"],
  data: function () {
    return {
      dynamicFormKey: 0,
      fetching: false,
      fetchingFull: false,
      valueToReturn: [],
      subBrandValue: [],
      subBrandOptions: [],
      drawerKey: 0,
      childParams: {},
      categoryOptions: [],
      supplierTypeOptions: [],
      supplierOptions: [],
      brandOptions: [],
      brandOptions2: [],
      subBrandOptions2: [],
      tagOptions: [],
      propertiesOptions: [],
      inputCategory: null,
      inputSupplierType: "0",
      inputSupplier: null,
      inputBrand: [],
      inputSubBrand: [],
      inputTag: [],
      statusFilter: "0",
      stockStatus: "0",
      inputDate: [],
      categories: [],
      isNonTrade: false,
      inputProperty: [],
      dateFormat: "MM-DD-YYYY",
      massUpdateMode: false,
      filterVisible: true,
      userDefinedFields: [],
      filterCaption: "",
      filterField: null,
      customFormMode: null,
      customForm: {},
      userDefinedFilters: {},
      productGroupOptions: [],
      inputProductGroup: [],
      productGradeOptions: ['NULL', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14,15,16],
      inputProductGrade: [],
      inputRetailPrice: null,
      inputProductSeriesName: [],
      productSeriesNameOptions: [
        {key: "new", name: "New"},
        {key: "repeat", name: "Repeat"},
        {key: "repeat_1", name: "Repeat 1"},
        {key: "repeat_2", name: "Repeat 2"},
        {key: "repeat_3", name: "Repeat 3"},
        {key: "repeat_4", name: "Repeat 4"},
        {key: "repeat_5", name: "Repeat 5"},
        {key: "repeat_6", name: "Repeat 6"},
        {key: "repeat_7", name: "Repeat 7"},
        {key: "repeat_8", name: "Repeat 8"},
        {key: "repeat_9", name: "Repeat 9"},
        {key: "repeat_10", name: "Repeat 10"},
      ],
      inputProductSeriesDate: null,
      inputProductCreateDate: null,
      inputProductUpdateDate: null,
    };
  },
  components: {
    DynamicForm,
  },
  computed: {
    ...mapState(["endPoint", "parentId", "parameters", "categoriesOptions"]),
  },
  mounted: async function () {
    // console.log(">>>>>>>>>>>>>>>>")
    // console.log(this)

    const sytemModule = await HTTPRequest.getRequest(
      this.endPoint + "system_modules/Products?field_name=name",
      null
    );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
      this.endPoint +
        "account_system_modules/" +
        sytemModuleId +
        "?field_name=system_module_id",
      null
    );

    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
      this.userDefinedFields = accSystemModule.customized_fields;
      if (accSystemModule != null) {
        if (accSystemModule.form_mode != undefined) {
          this.customFormMode = accSystemModule.form_mode;
        }

        if (accSystemModule.customized_forms != undefined) {
          this.customForm = accSystemModule.customized_forms;
        }
      }
      if (!_.isEmpty(this.$attrs.parentParams))
        this.userDefinedFilters = this.$attrs.parentParams;
    }

    this.dynamicFormKey++;
    this.fetchingFull = true;

    var originalParameters = this.$attrs.parentParams || this.parentParams;
    if (!_.isEmpty(originalParameters)) {
      this.inputCategory = originalParameters["inputCategory"];
      this.valueToReturn = originalParameters["inputBrand"];
      this.inputBrand = originalParameters["inputBrand"];
      this.inputSubBrand = originalParameters["inputSubBrand"];
      this.subBrandValue = originalParameters["inputSubBrand"]
      this.inputProductGroup = originalParameters["inputProductGroup"];
      this.inputProductGrade = originalParameters["inputProductGrade"];
      this.inputSupplierType = originalParameters["inputSupplierType"];
      this.inputSupplier = originalParameters["inputSupplier"];
      this.inputDate = originalParameters["inputDate"];
      this.statusFilter = originalParameters["statusFilter"];
      this.inputTag = originalParameters["inputTag"];
      this.dateString = originalParameters["dateString"];
      this.isNonTrade = originalParameters["isNonTrade"];
      this.stockStatus = originalParameters["stockStatus"];
      this.inputRetailPrice = originalParameters["inputRetailPrice"];
      this.inputProductSeriesName = originalParameters["inputProductSeriesName"];
      this.inputProductSeriesDate = originalParameters["inputProductSeriesDate"];
      this.inputProductCreateDate = originalParameters["inputProductCreateDate"];
      this.inputProductUpdateDate = originalParameters["inputProductUpdateDate"];
    }

    this.massUpdateMode = this.$attrs.massUpdateMode;
    // this.categoryOptions = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);

    var categories = await HTTPRequest.getRequest(
      this.endPoint + "categories/get_valid_categories",
      null
    );
    this.categories = categories;

    var suppliers = await HTTPRequest.getRequest(
      this.endPoint + "suppliers/get_valid_suppliers",
      null
    );
    this.supplierOptions = suppliers;
    this.sort(this.supplierOptions);

    var supplier_types = await HTTPRequest.getRequest(
      this.endPoint + "supplier_types/get_valid_supplier_types",
      null
    );
    this.supplierTypeOptions = supplier_types;
    this.sort(this.supplierTypeOptions);

    var brands_complete = await HTTPRequest.getRequest(
      this.endPoint + "brands/get_valid_brands?mode=all",
      null
    );
    this.brandOptions2 = brands_complete;

    var brands = await HTTPRequest.getRequest(
      this.endPoint + "brands/get_valid_brands",
      null
    );
    if (brands.length > 100) {
      this.brandOptions = [];
    } else {
      this.brandOptions = brands;
      this.sort(this.brandOptions);
    }

    var tags = await HTTPRequest.getRequest(
      this.endPoint + "product_lines/get_valid_tags",
      null
    );
    this.tagOptions = tags;
    this.sort(this.tagOptions);

    var properties = await HTTPRequest.getRequest(
      this.endPoint + "properties/get_valid_properties",
      null
    );
    this.propertiesOptions = properties;
    this.sort(this.propertiesOptions);

    this.fetchingFull = false;
    this.getProductGroupData();
  },
  watch: {
    inputSupplierType: async function () {
      this.inputSupplier = null;
      var suppliers;
      if (this.inputSupplierType != "0") {
        suppliers = await HTTPRequest.getRequest(
          this.endPoint +
            "suppliers/get_valid_suppliers?supplier_type_id=" +
            this.inputSupplierType,
          null
        );
      } else {
        suppliers = await HTTPRequest.getRequest(
          this.endPoint + "suppliers/get_valid_suppliers",
          null
        );
      }

      this.supplierOptions = suppliers;
      this.sort(this.supplierOptions);
    },
    valueToReturn: async function(){
      // remove sub brand if brand is remove
      this.subBrandOptions = [];
      let subBrands = await HTTPRequest.getRequest(
        this.endPoint + "sub_brands/get_valid_sub_brands?mode=multiple&brand_ids=" + this.valueToReturn, null
      );
      this.subBrandOptions = subBrands;
      let subBrandOptions = this.subBrandOptions.map(x => x.id);
      let subBrandVal = this.subBrandValue;

      this.subBrandValue = subBrandVal.filter(item => subBrandOptions.includes(item))
      // console.log(this.subBrandValue)
    },
    currentFilter: function () {
      console.log(this.currentFilter);
    },
  },
  methods: {
    moment,
    ...mapActions(["updateParentId", "updateParameters"]),
    async handleSearch(value) {
      this.fetching = true;
      var brands = await HTTPRequest.getRequest(
        this.endPoint + "/brands/get_valid_brands?name=" + value,
        null,
        null
      );
      this.brandOptions = brands;
      this.fetching = false;
    },
    // get product group data method
    async getProductGroupData() {
      var product_group_data = await HTTPRequest.getRequest(
        this.endPoint + "product_groups/get_valid_product_groups",
        null
      );

      this.productGroupOptions = product_group_data;
    },
    changeFilter(field) {
      this.filterField = field.code;
      this.filterCaption = "Search by " + _.startCase(field.name);
    },
    handleChange(event, returnVal, input ) {
      this[returnVal] = event;
      this[input] = event;
    },

    updateProductSeriesDate(date){
      if (date != null) {
        this.inputProductSeriesDate = moment(date).format("MMMM DD, YYYY");
      }
    },

    updateProductCreateDate(date){
      if(date != null){
        this.inputProductCreateDate = moment(date).format("MMMM DD, YYYY");
      }
    },

    updateProductUpdateDate(date){
      if(date != null){
        this.inputProductUpdateDate = moment(date).format("MMMM DD, YYYY");
      }
    },

    onClose() {
      this.$emit("closeFilter")
      this.filterVisible = false;
      // this.updateParams(); 
    },
    isJsonString(str) {
      try {
        var json = JSON.parse(str);
        return typeof json === "object";
      } catch (e) {
        return false;
      }
    },
    sort(data) {
      data = data.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      this.data = data;
    },
    triggerManageCategories() {
      this.$emit("manageCategory", null);
    },
    updateParams() {
      var actualParams = {};
      // this.childParams = this.params;
      // console.log(this.inputCategory);
      actualParams["inputCategory"] = this.inputCategory;
      actualParams["inputBrand"] = this.inputBrand;
      actualParams["inputSubBrand"] = this.inputSubBrand;
      actualParams["inputSupplierType"] = this.inputSupplierType;
      actualParams["inputSupplier"] = this.inputSupplier;
      actualParams["inputDate"] = this.inputDate;
      actualParams["statusFilter"] = this.statusFilter;
      actualParams["inputTag"] = this.inputTag;
      actualParams["dateString"] = this.dateString;
      actualParams["isNonTrade"] = this.isNonTrade;
      actualParams["stockStatus"] = this.stockStatus;
      actualParams["inputProductGroup"] = this.inputProductGroup;
      actualParams["inputProductGrade"] = this.inputProductGrade;
      actualParams["inputRetailPrice"] = this.inputRetailPrice;
      actualParams["inputProductSeriesName"] = this.inputProductSeriesName;
      actualParams["inputProductSeriesDate"] = this.inputProductSeriesDate;
      actualParams["inputProductCreateDate"] = this.inputProductCreateDate;
      actualParams["inputProductUpdateDate"] = this.inputProductUpdateDate;

      if (
        this.inputCategory != null &&
        this.inputCategory != "" &&
        this.inputCategory != "0"
      ) {
        var resultLength = this.inputCategory.length;
        switch (resultLength) {
          case 5:
            this.childParams["category_id"] = this.inputCategory[4];
            this.categories.map((value) => {
              if (
                value.id == this.childParams["category_id"] &&
                value.level == 4
              )
                this.childParams["category_name"] = value.name;
            });
            break;
          case 4:
            this.childParams["section_id"] = this.inputCategory[3];
            this.categories.map((value) => {
              if (
                value.id == this.childParams["section_id"] &&
                value.level == 3
              )
                this.childParams["category_name"] = value.name;
            });
            break;
          case 3:
            this.childParams["department_id"] = this.inputCategory[2];
            this.categories.map((value) => {
              if (
                value.id == this.childParams["department_id"] &&
                value.level == 2
              )
                this.childParams["category_name"] = value.name;
            });
            break;
          case 2:
            this.childParams["division_id"] = this.inputCategory[1];
            this.categories.map((value) => {
              if (
                value.id == this.childParams["division_id"] &&
                value.level == 1
              )
                this.childParams["category_name"] = value.name;
            });
            break;
        }
      }

      if (this.isNonTrade == true) {
        this.childParams["is_non_trade"] = this.isNonTrade;
      }

      if (this.stockStatus != "0") {
        this.childParams["stock_status"] = this.stockStatus;
      }

      // this.childParams["brand_id"] = this.inputBrand
      this.childParams["brand_id"] = this.valueToReturn;
      this.childParams["brand_names"] = [];
      if (this.childParams["brand_id"] != undefined) {
        this.brandOptions2.map((value) => {
          if (this.childParams["brand_id"].includes(value.id))
            this.childParams["brand_names"].push(value.name);
        });
      }

      this.childParams["sub_brand_id"] = this.subBrandValue;
      this.childParams["sub_brand_names"] = [];
      if(this.childParams["sub_brand_id"] != null) {
        this.subBrandOptions.map((value) => {
            if(this.childParams["sub_brand_id"].includes(value.id))
              this.childParams["sub_brand_names"].push(value.name)
          }
        )
      }

      this.childParams["product_group_id"] = this.inputProductGroup;
      this.childParams["product_group_names"] = [];
      if(this.childParams["product_group_id"] != null) {
        this.productGroupOptions.map((value) => {
            if(this.childParams["product_group_id"].includes(value.id))
              this.childParams["product_group_names"].push(value.name)
          }
        )
      }

      this.childParams["product_series_name"] = this.inputProductSeriesName;

      this.childParams["product_series_date"] = this.inputProductSeriesDate;
      this.childParams["created_at"] = this.inputProductCreateDate;
      this.childParams["updated_at"] = this.inputProductUpdateDate;

      this.childParams["product_grade_level"] = this.inputProductGrade;
      this.childParams["retail_price"] = this.inputRetailPrice;
      this.childParams["product_line_id"] = this.inputTag;

      if (this.childParams["product_line_id"] != undefined) {
        this.childParams["tag_names"] = [];
        this.tagOptions.map((value) => {
          if (this.childParams["product_line_id"].includes(value.id))
            this.childParams["tag_names"].push(value.name);
        });
      }

      if (this.inputSupplier != "0") {
        this.childParams["supplier_id"] = this.inputSupplier;
        this.supplierOptions.map((value) => {
          if (value.id == this.childParams["supplier_id"])
            this.childParams["supplier_name"] = value.name;
        });
      }

      if (this.statusFilter != "0") {
        this.childParams["status"] = this.statusFilter;
      }

      //  POST-PROCESSING
      if (this.inputBrand.length == 0) delete this.childParams["brand_id"];
      if (this.inputSubBrand.length == 0) delete this.childParams["sub_brand_id"]
      if (this.inputProductGroup.length == 0)
        delete this.childParams["product_group_id"];
      if(this.inputProductSeriesName.length == 0){
        delete this.childParams["product_series_name"];
      }
      if(this.inputProductSeriesDate == null){
        delete this.childParams["product_series_date"]
      }

      if(this.inputProductCreateDate == null){
        delete this.childParams["created_at"]
      }
      if(this.inputProductUpdateDate == null){
        delete this.childParams["updated_at"]
      }
      if (this.inputProductGrade == 0)
        delete this.childParams["product_grade_level"];
      if (this.inputRetailPrice == null){
        delete this.childParams["retail_price"]
      }
      if (this.inputTag.length == 0) delete this.childParams["product_line_id"];
      if (this.inputSupplier == null || this.inputSupplier == "0")
        delete this.childParams["supplier_id"];
      if (this.statusFilter == null || this.statusFilter == "0")
        delete this.childParams["status"];
      if (this.dateString != undefined) {
        this.childParams["start_date"] = this.dateString[0];
        this.childParams["end_date"] = this.dateString[1];
        if (this.dateString[0] == "" || this.dateString[1] == "") {
          delete this.childParams["start_date"];
          delete this.childParams["end_date"];
        }
      }

      // console.log("ProductAdvanceFilter: " + this.massUpdateMode);
      this.filterVisible = false;
      // this.childParams = Object.assign(this.childParams, this.userDefinedFilters)
      // actualParams = Object.assign(actualParams, this.userDefinedFilters)
      // this.childParams.merge(this.userDefinedFilters);
      // actualParams.merge(this.userDefinedFilters)
      // console.log("****!!!****");
      // console.log(this.childParams);
      // console.log(actualParams);
      let merged1 = { ...this.childParams, ...this.userDefinedFilters };
      let merged2 = { ...actualParams, ...this.userDefinedFilters };
      // console.log("****!!!****");
      // console.log(merged1);
      // console.log(merged2);

      this.$emit("changeParams", merged1, merged2, this.massUpdateMode);
    },
    clearFilter() {
      this.inputCategory = null;
      this.inputSupplierType = "0";
      this.inputSupplier = null;
      this.inputProductGroup = [];
      this.inputProductGrade = [];
      this.inputBrand = [];
      this.inputSubBrand = [];
      this.inputTag = [];
      this.statusFilter = "0";
      this.childParams = {};
      this.isNonTrade = false;
      this.inputRetailPrice= null;
      this.inputProductSeriesName = [];
      this.inputProductSeriesDate = null;
      this.valueToReturn=[] 
      this.inputProperty = []
      this.stockStatus = "0"
      // this.$emit("changeParams", this.childParams, null);
    },
    async filter(inputValue, path) {
      if (inputValue.length >= 3) {
        // console.log(inputValue)
        this.categoryOptions = await HTTPRequest.getRequest(
          this.endPoint + "categories/cascader_view?name=" + inputValue,
          null
        );
      }
      //
      // alert(inputValue)
      // return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onDateFilter(date, dateString) {
      this.inputDate = date;
      this.dateString = dateString;
    },
    filterViaUDF() {},
  },
};
</script>
